module.exports = __webpack_public_path__ + "img/BS20.36c1bada.svg";